<template lang="pug">
  div#contact
    v-btn(v-if="!callFromMenu"
      fab
      small
      color="pink white--text"
      @click.stop="openDialog"
    )
      v-icon add

    <!--v-btn(text icon small @click.stop="openDialog" color="white" class="" v-if="callFromMenu")-->
      <!--v-icon local_phone-->

    v-dialog(no-click-animation :key="keyDialog" persistent v-model="dialog" max-width=900, hide-overlay, scrollable)
      v-card(v-if="one !== null")
        v-card-title.app-append.white--text
          span 問い合わせ追加
          v-spacer
          v-btn(text small icon color="white" @click.stop="close")
            v-icon close

        v-card-text
          div.padding-bottom-20
            contact-info(ref="info" :customers="customers" :members="members" :items="items"
            :genuses="genuses" :units="units"
            :boxTypes="boxTypes" :countries="countries" :suppliers="suppliers" :typeContact="typeContact")
          app-action(ref="action")
          div.padding-bottom-20 画像・ファイル
          div
            dropzone(:multiple="true" @remove="removeUploadImg" @select="select" :key="dropzoneKey")
        v-card-actions
          v-spacer
          v-flex(xs3)
            v-select.min-height-auto(
            height="24"
            :items="statuses"
            item-text="name"
            item-value="id"
            v-model="status"
            )
          v-btn(
            text
            color="app-append"
            @click.stop="save")
            span {{$t('save')}}
</template>

<script>
import rules from '@/common/mixins/rules'
import {mapGetters, mapMutations, mapActions} from 'vuex'
import datepick from '@/common/mixins/datepick'
import dropzone from '@/common/components/Dropzone'
import ContactInfo from './ContactInfo'
import AppAction from './action'
import token from '@/common/services/token'

export default {
  components: {dropzone, ContactInfo, AppAction},
  data () {
    return {
      member: null,
      types: false,
      status: 1,
      dialog: false,
      one: null,
      exclusiveLock: false,
      contact_date_picker: false,
      mail_send_date_picker: false,
      mail_send_time_picker: false,
      dropzoneKey: Math.random(),
      keyDialog: Math.random()
    }
  },
  props: {
    callFromMenu: {
      type: Boolean,
      required: false
    },
    dialogContact: {
      type: Boolean,
      required: false
    }
  },
  watch: {
    dialog (val) {
      if (!val) {
        this.one = null
      }
    },
    dialogContact (newVal, oldVal) {
      if (!oldVal && newVal) {
        this.openDialog()
      }
    }
  },
  computed: {
    ...mapGetters('common/account', ['isMeLoaded', 'me', 'hasRole']),
    ...mapGetters('app/ct', [
      'info',
      'action',
      'customers',
      'members',
      'items',
      'varieties',
      'sizes',
      'typeContact',
      'statuses',
      'boxTypes',
      'units',
      'genuses',
      'suppliers',
      'countries'
    ])
  },
  created () {
    this.$emit('entermove-refresh-request')
  },
  mixins: [rules, datepick],
  methods: {
    ...mapMutations('app/ct', ['updateInfo', 'updateAction']),
    ...mapActions('app/ct', [
      'updateInfo',
      'updateAction',
      'setCustomers',
      'setMembers',
      'setItems',
      'setVarieties',
      'setSizes',
      'setTypeContact',
      'setStatuses',
      'setBoxTypes',
      'setUnits',
      'setGenuses',
      'setSuppliers',
      'setCountries',
      'emptyContactStore'
    ]),
    select (files) {
      this.dealFile(files)
    },
    removeUploadImg (index) {
      this.$store.commit('app/ct/removePendingUploadContactFiles', index)
    },
    dealFile (files) {
      for (let fo of files) {
        if (fo.size > 20000000) {
          this.$toastr.error('filesize_over')
          return false
        }
        let reader = new FileReader()
        let file = {
          id: null,
          token: token.publishToken(),
          name: fo.name,
          size: fo.size,
          filetype: fo.type,
          removed: false
        }
        reader.readAsDataURL(fo)
        reader.onloadend = e => {
          file.payload = reader.result
          this.$store.commit('app/ct/addContactFiles', file)
        }
      }
    },
    openDialog () {
      if (this.customers.length === 0) {
        this.$ajax.get('/customer/list')
          .then((response) => {
            this.setCustomers(response.data)
          })
          .catch((messages, error) => {
            messages.map((message) => this.$toastr.error(message))
          })
      }

      if (this.members.length === 0) {
        this.$ajax.get('/member/list')
          .then((response) => {
            this.setMembers(response.data)
            this.setMemberByMe()
          })
          .catch((messages, error) => {
            messages.map((message) => this.$toastr.error(message))
          })
      }

      if (this.typeContact.length === 0) {
        this.$ajax.get('/contact_type/list')
          .then((response) => {
            let typeContact = response.data
            typeContact = typeContact.sort((a, b) => {
              return a.id - b.id
            })
            this.setTypeContact(typeContact)
          })
          .catch((messages, error) => {
            messages.map((message) => this.$toastr.error(message))
          })
      }

      if (this.statuses.length === 0) {
        this.$ajax.get('/contact/status/list')
          .then((response) => {
            this.setStatuses(response.data)
          })
          .catch((messages, error) => {
            messages.map((message) => this.$toastr.error(message))
          })
      }

      if (this.items.length === 0) {
        this.$ajax.get(`/item/list`)
          .then((response) => {
            this.setItems(response.data)
          })
          .catch((messages, error) => {
            messages.map((message) => this.$toastr.error(message))
          })
      }

      if (this.boxTypes.length === 0) {
        // Load list box type
        this.$ajax
          .get('/box/type/list')
          .then(response => {
            this.setBoxTypes(response.data)
          })
          .catch((messages, error) => {
            messages.map(message => this.$toastr.error(message))
          })
      }

      if (this.units.length === 0) {
        // Load list unit
        this.$ajax
          .get('/unit/list')
          .then(response => {
            this.setUnits(response.data)
          })
          .catch((messages, error) => {
            messages.map(message => this.$toastr.error(message))
          })
      }

      if (this.genuses.length === 0) {
        // Load list genus
        this.$ajax
          .get('/genus/list')
          .then(response => {
            this.setGenuses(response.data)
          })
          .catch((messages, error) => {
            messages.map(message => this.$toastr.error(message))
          })
      }

      if (this.suppliers.length === 0) {
        this.$ajax.get('/supplier/list')
          .then((response) => {
            this.setSuppliers(response.data)
          })
          .catch((messages, error) => {
            messages.map((message) => this.$toastr.error(message))
          })
      }

      if (this.countries.length === 0) {
        this.$ajax.get('/country/list')
          .then((response) => {
            this.setCountries(response.data)
          })
          .catch((messages, error) => {
            messages.map((message) => this.$toastr.error(message))
          })
      }

      if (this.members.length) {
        this.setMemberByMe()
      }

      this.one = {
        id: null,
        member: this.member,
        contact_type: null,
        contact_date: this.$moment().format('YYYY-MM-DD'),
        contact_detail: '',
        contact_name: '',
        is_remind_mail: false,
        mail_send_date: null,
        mail_send_time: null,
        done: false,
        version: 1
      }
      this.updateInfo({member: this.member})
      this.updateInfo({contact_type: 0})
      this.resetRuleError()
      this.dialog = true
      this.$emit('entermove-refresh-request')
    },
    setMemberByMe () {
      let index = this.members.findIndex((row) => {
        return row.uuid === this.me.uuid
      })
      if (index > -1) {
        this.member = this.members[index]
        this.updateInfo({member: this.member})
      }
    },
    save () {
      let objParam = JSON.parse(JSON.stringify(this.info))
      let actionParam = { ...this.action }
      let info = this.$refs.info
      // let action = this.$refs.action
      let infoErr = info.hasRuleError()
      if (infoErr || typeof objParam.contact_type === 'undefined') {
        this.$toastr.warning(this.$t('common.rules.invalidate_message'))
        return true
      }
      if (this.exclusiveLock) {
        return
      }
      this.exclusiveLock = true

      objParam.id = null
      objParam.contact_type = this.typeContact[objParam.contact_type].id
      if (objParam.customer) {
        objParam.customer = objParam.customer.id
      }
      if (actionParam) {
        if (actionParam.chart_detail_ids && actionParam.chart_detail_ids.length) {
          objParam.chart_details = [...new Set(actionParam.chart_detail_ids)]
          if (actionParam.chart_details && actionParam.chart_details.length) {
            objParam.chart_details.concat(this.pluck(actionParam.chart_details, 'id'))
          }
        }

        if (actionParam.is_order_finished) {
          objParam.is_order_finished = actionParam.is_order_finished
        }

        if (actionParam.order_memo) {
          objParam.order_memo = actionParam.order_memo
        }
      }

      if (objParam.contact_date) {
        if (!objParam.contact_time) {
          objParam.contact_time = '00:00'
        }
        objParam.contact_time = objParam.contact_date + ' ' + objParam.contact_time + ':00'
      }

      objParam.contact_products = objParam.contact_products.filter(product => product.id || (!product.id && product.removed !== true))
      for (let product of objParam.contact_products) {
        if (!product.id) {
          product.id = null
        }
        if (product.item) {
          product.item = product.item.id
        }

        if (product.variety) {
          product.variety = product.variety.id
        }

        if (product.size) {
          product.size = product.size.id
        }

        if (product.country) {
          product.country = product.country.id
        }

        if (product.supplier) {
          product.supplier = product.supplier.id
        }
      }

      if (objParam.member) {
        objParam.member = objParam.member.id
      }

      if (objParam.reminder_date) {
        if (!objParam.reminder_time) {
          objParam.reminder_time = '00:00'
        }
        objParam.reminder = objParam.reminder_date + ' ' + objParam.reminder_time + ':00'
      }
      objParam.status = this.status
      objParam.related_contact = null
      this.$ajax
        .post('/contact/save', objParam)
        .then(response => {
          this.$emit('complete', response.data)
          this.close()
        })
        .catch((messages, error) => {
          this.exclusiveLock = false
          messages.map(message => this.$toastr.error(message))
        })
    },
    pluck (arr, prop) {
      return [...new Set(arr.map(r => r[prop]))]
    },
    resetKey () {
      this.dropzoneKey = Math.random()
      this.keyDialog = Math.random()
    },
    close () {
      this.exclusiveLock = false
      this.dialog = false
      this.$emit('closeDialogContact')
      this.emptyContactStore()
      this.resetKey()
    }
  }
}
</script>

<style scoped lang="stylus">
.padding-bottom-20 {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/app/pages/Contact/append.vue